import { safelyDecodeBase64Url } from '@dev/ee-tools';

// `List = '${getSafeRuleListName(listname, true)}'`;
const getSafeRuleListName = (listName?: string, decode?: boolean): string => {
    const safeName = `${listName?.replace(/'/g, "\\'") ?? ''}`;
    if (decode) {
        return safelyDecodeBase64Url(safeName);
    }
    return safeName;
};
export default getSafeRuleListName;
